var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container",on:{"click":_vm.routerTo}},[_c('div',{staticClass:"button-container-flex"},[(_vm.icon)?_c('svg-icon',{staticClass:"button-icon",staticStyle:{"margin-right":"10px"},attrs:{"icon-class":_vm.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }